import { useState, useContext, useEffect } from "react";
import styles from "./banner.module.scss";
import { AppContext } from "helpers/context";
import { updateUserNotifications } from "api/layer";

export default function MessageBanner() {
  const [context] = useContext(AppContext);
  const [dismissedIds, setDismissedIds] = useState<Set<string>>(new Set());

  const bannerNotifications = (
    context.userNotifications as { bannerNotifications?: any[] }
  )?.bannerNotifications;

  const unreadBanners = bannerNotifications?.filter(
    (n) => !dismissedIds.has(n.notificationId)
  );
  const currentBanner = unreadBanners?.[0];

  const showBanner = !!currentBanner;

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--banner-h",
      showBanner ? "40px" : "0px"
    );
    return () => {
      document.documentElement.style.setProperty("--banner-h", "0px");
    };
  }, [showBanner]);

  if (!showBanner) {
    return null;
  }

  const handleClose = () => {
    if (currentBanner?.notificationId) {
      setDismissedIds((prev) =>
        new Set(prev).add(currentBanner.notificationId)
      );
      updateUserNotifications([
        {
          notificationId: currentBanner.notificationId,
          notificationCategory: currentBanner.notificationCategory,
          isRead: true,
        },
      ]);
    }
  };

  return (
    <div className="w-full h-10 bg-[#F9E060] flex items-center justify-between p-4 text-[12px]">
      <div className="flex items-center">
        <div className="mr-2 mt-[5px]">
          <div className="material-icons-outlined text-[16px]">info</div>
        </div>
        {currentBanner?.notificationHeader?.notificationHeaderMessage}
      </div>
      <div className={styles.closeIcon} onClick={handleClose}>
        <div className="material-icons">close</div>
      </div>
    </div>
  );
}
